var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(0 -310)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M9.039,19.668V13.822l-1,1a1.046,1.046,0,1,1-1.479-1.479l2.791-2.791a1.051,1.051,0,0,1,1.144-.223,1.034,1.034,0,0,1,.642.963v8.372a1.047,1.047,0,0,1-2.093,0Z",
    transform: "translate(0.727 312.309)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M11.346,14.826,8.555,12.035a1.046,1.046,0,1,1,1.479-1.479l2.791,2.791a1.053,1.053,0,0,1,0,1.479,1.044,1.044,0,0,1-1.479,0Z",
    transform: "translate(1.519 312.309)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M12.064,31.25C4.487,31.25,1.25,28.013,1.25,20.436V12.064C1.25,4.487,4.487,1.25,12.064,1.25h6.977a1.047,1.047,0,1,1,0,2.093H12.064c-6.433,0-8.721,2.288-8.721,8.721v8.372c0,6.433,2.288,8.721,8.721,8.721h8.372c6.433,0,8.721-2.288,8.721-8.721V13.459a1.047,1.047,0,0,1,2.093,0v6.977c0,7.577-3.237,10.814-10.814,10.814Z",
    transform: "translate(-1.25 308.75)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M19.878,14.505c-4.772,0-6.628-1.856-6.628-6.628V2.3a1.034,1.034,0,0,1,.642-.963,1.056,1.056,0,0,1,1.144.223L26.2,12.719a1.047,1.047,0,0,1-.74,1.786ZM15.343,7.877c0,3.6.935,4.535,4.535,4.535h3.056L15.343,4.821Z",
    transform: "translate(3.494 308.751)",
    fill: "#15345a",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/uploadicon.619287736a20969c9aaf932cc1a14421.svg";
export { ForwardRef as ReactComponent };